export enum DeliveryMethodEnum {
  E = 'existing',
  P = 'pickupPoint',
  N = 'new',
}
